import React, { useEffect, useState } from 'react';
import { TextField, Button, Container, Typography, Alert, Box, Modal, TextareaAutosize, ButtonGroup, IconButton, CircularProgress, Select, MenuItem } from '@mui/material';
import { req, reqPoll } from './ServerUtils';
import ImagesUploader from './ImagesUploader';
import { useParams } from 'react-router-dom';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import QuoteInspirationUploader from './QuoteInspirationUploader';


const QuoteTemplateCreator = () => {
  const [templateInspiration, setTemplateInspiration] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  const [likes, setLikes] = useState(0);
  const [comments, setComments] = useState(0);
  const [reposts, setReposts] = useState(0);
  const [postLink, setPostLink] = useState('');

  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);
  const [successImage, setSuccessImage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    req('/user_info').then(uinfo => {
      setUserInfo(uinfo);
      if (!uinfo) {
        if (!uinfo.permissions.includes("designer")) {
          req('/sus', 'POST', {
            'reason': 'Unauthorized access attempt to /templates'
          });
        }
        window.location.href = '/login';
        return;
      }
      setLoading(false);
    }).catch(e=> {
      window.location = '/login';
    })
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("inspiration", templateInspiration);
    formData.append("likes", likes);
    formData.append("comments", comments);
    formData.append("reposts", reposts);
    formData.append("post_link", postLink);
    setLoading(true);

    req("/designer/quote-templates", "PUT", formData, false)
    .then(r => {
      console.log(r);
      setLoading(false);
      setSuccess("Template created successfully, likes: " + r.template?.likes + ", comments: " + r.template?.comments + ", reposts: " + r.template?.reposts);
      setSuccessImage('https://cdn.makemybrand.ai/' + r.template?.inspiration)
    })
  };

  if (!userInfo || !userInfo.permissions.includes("designer")) {
    return (<div>Loading...</div>);
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 5, display: 'flex', gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <Box component="form" onSubmit={(e) => e.preventDefault()}>
           
            <QuoteInspirationUploader setTemplateInspiration={file => {
                setTemplateInspiration(file);
            }} />
            <TextField fullWidth label="Likes" variant="outlined" margin="normal" value={likes} onChange={(e) => setLikes(e.target.value)} />
            <TextField fullWidth label="Comments" variant="outlined" margin="normal" value={comments} onChange={(e) => setComments(e.target.value)} />
            <TextField fullWidth label="Reposts" variant="outlined" margin="normal" value={reposts} onChange={(e) => setReposts(e.target.value)} />
            <TextField fullWidth label="Post Link" variant="outlined" margin="normal" value={postLink} onChange={(e) => setPostLink(e.target.value)} />
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                <Button variant="contained" color="primary" onClick={onSave} disabled={loading || templateInspiration?.length == 0}>
                    Submit
                </Button>
                {loading && <CircularProgress />}
            </Box>
        </Box>
        {error && (
          <Alert severity={error?.startsWith('Error') ? 'error' : 'success'} sx={{ mt: 3 }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mt: 3 }}>
            {success}
          </Alert>
        )}
        {successImage && (
          <img src={successImage} alt="Success" style={{
            width: "200px"
          }} />
        )}
      </Box>
    </Container>
  );
};

export default QuoteTemplateCreator;
